// Hotkeys
export const VIDEO_JUMP_FORWARD_l_KEY = 'l';
export const VIDEO_JUMP_BACKWARD_j_KEY = 'j';
export const VIDEO_JUMP_FORWARD = [
  'ArrowRight',
  'Right',
  VIDEO_JUMP_FORWARD_l_KEY,
]; // 'Right' for IE comp.
export const VIDEO_JUMP_BACK = ['ArrowLeft', 'Left', VIDEO_JUMP_BACKWARD_j_KEY]; // 'Left' for IE comp.
export const VIDEO_MUTE = ['m'];
export const VIDEO_STEP_FORWARD = ['.'];
export const VIDEO_STEP_BACK = [','];
export const VIDEO_PLAY_PAUSE = ['k', ' '];
export const VIDEO_TOGGLE_FULLSCREEN = ['f'];
export const VIDEO_PICTURE_IN_PICTURE = ['p'];
export const VIDEO_ENTER_COMMENT_MODE = ['c'];
export const VIDEO_TOGGLE_SPEED = ['s'];
export const VIDEO_TOGGLE_TRANSCRIPT = ['n', 'Escape'];
export const VIDEO_TOGGLE_THEATER = ['t'];
export const VIDEO_VOLUME_UP = ['ArrowUp', 'Up']; // 'Up' for IE comp.
export const VIDEO_VOLUME_DOWN = ['ArrowDown', 'Down']; // 'Down' for IE comp.
export const VIDEO_TOGGLE_CAPTIONS = ['a'];
export const VIDEO_ENTER_TRIM_MODE = ['/'];
export const MODAL_CLOSE = ['Escape'];

// These keyboard shortcuts only apply in trim mode.
export const TRIM_SPLIT_PLAY_RANGE = ['/'];
export const TRIM_DELETE_PLAY_RANGE = ['Backspace', 'Delete'];
export const TRIM_DESELECT_HANDLE = ['Escape'];

// this keyboard shortcut requires ctrl/cmd to be pressed
export const TRIM_UNDO_REDO = ['z'];
